export { CalculatorIcon } from './calculator'
